import React from "react";
import { DeleteDialogProps } from "../../../../shared/services/interface";
import { ModalWrapper } from "../../../../shared/components/ModalWrapper";
import CommonButtons from "src/shared/components/CommonButtons";

const DeleteDialog: React.FC<DeleteDialogProps> = ({ open, onClose, onConfirm }) => {
  if (!open) return null;

  return (
    <ModalWrapper title="Delete Order" onClose={onClose} showCloseButton={true} showBackButton={false} width="max-w-md" >
      <div className="flex flex-col items-center justify-center text-center space-y-6">
        <p className="text-lg">Are you sure you want to delete this order?</p>
        <div className="flex justify-center gap-6 mt-6">
          <CommonButtons className="w-36" label="Cancel" variant="outlineDanger" onClick={onClose}/>
          <CommonButtons className="w-36" label="Confirm" onClick={onConfirm}/>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default DeleteDialog;
